import envRaw from './env-raw'

let id = 0
const nextId = () => id++

export default function MapSimple() {
  const keys = []
  const values = []
  let pairsLimit = 50

  const mapSimple = {
    id: nextId(),
    set,
    get,
    has,
    del,
    keys: getKeys,
    values: getValues,
    size,
    pairs,
    clear,
    delete: del,
    replace,
    getIndex,
    getByIndex,
    delByIndex,
    replaceByIndex,
    setAndGetIndex,
    delByValue,
    getMaxPairs,
    setMaxPairs
  }

  return mapSimple

  function getKeys() {
    return keys.concat()
  }

  function getValues() {
    return values.concat()
  }

  function pairs() {
    const result = []
    for (let index = 0, length = keys.length; index !== length; index++) {
      const key = keys[index]
      const val = values[index]
      result.push([key, val])
    }
    return result
  }

  function size() {
    return keys.length
  }

  function getMaxPairs() {
    return pairsLimit
  }

  function setMaxPairs(limit) {
    pairsLimit = limit
    return mapSimple
  }

  function replace(key, val) {
    const index = getIndex(key)
    if (index === -1) {
      return set(key, val)
    } else {
      keys[index] = key
      values[index] = val
      return val
    }
  }

  function set(key, val) {
    keys.push(key)
    values.push(val)
    if (envRaw.devMode && keys.length > pairsLimit) {
      console.warn(`possible MapSimple#${mapSimple.id} memory leak detected. ${keys.length} pairs added!`)
    }
    return val
  }

  function get(key) {
    const index = keys.indexOf(key)
    return index !== -1
      ? values[index]
      : undefined
  }

  function has(key) {
    const index = keys.indexOf(key)
    return index !== -1
  }

  function del(key) {
    const index = keys.indexOf(key)
    if (index !== -1) {
      keys.splice(index, 1)
      values.splice(index, 1)
      return true
    } else {
      return true
    }
  }

  function getIndex(key) {
    return keys.indexOf(key)
  }

  function getByIndex(index) {
    if (index === -1) {
      return undefined
    }

    return index >= values.length
      ? undefined
      : values[index]
  }

  function delByIndex(index) {
    if (index === -1) {
      return false
    }

    if (index >= values.length) {
      return false
    }

    keys.splice(index, 1)
    values.splice(index, 1)
    return true
  }

  function replaceByIndex(index, val) {
    if (index === -1) {
      return false
    }

    if (index >= values.length) {
      return false
    }

    values[index] = val
    return true
  }

  function setAndGetIndex(key, val) {
    keys.push(key)
    values.push(val)
    if (envRaw.devMode && keys.length > pairsLimit) {
      console.warn(`possible MapSimple#${mapSimple.id} memory leak detected. ${keys.length} pairs added!`)
    }
    return keys.length - 1
  }

  function delByValue(val) {
    let index = -1
    let count = 0
    while ((index = values.indexOf(val)) !== -1) {
      count++
      keys.splice(index, 1)
      values.splice(index, 1)
    }
    return count
  }

  function clear() {
    keys.length = 0
    values.length = 0
    return mapSimple
  }
}
